// @flow
import {
  DELETE_MEASUREMENT_LOADING,
  DELETE_MEASUREMENT_SUCCESS,
  DELETE_MEASUREMENT_ERROR,
  ADD_MEASUREMENT_LOADING,
  ADD_MEASUREMENT_SUCCESS,
  ADD_MEASUREMENT_ERROR,
  UPDATE_MEASUREMENT_LOADING,
  UPDATE_MEASUREMENT_SUCCESS,
  UPDATE_MEASUREMENT_ERROR,
} from '../actions/growthChartActions';

export default (state: Object = {}, action: Object) => {
  switch (action.type) {
    case DELETE_MEASUREMENT_LOADING:
    case ADD_MEASUREMENT_LOADING:
    case UPDATE_MEASUREMENT_LOADING:
      return {
        ...state,
        status: 'LOADING',
      };
    case DELETE_MEASUREMENT_SUCCESS:
    case ADD_MEASUREMENT_SUCCESS:
    case UPDATE_MEASUREMENT_SUCCESS:
      return {
        ...state,
        status: 'SUCCESS',
        data: action.data,
      };
    case DELETE_MEASUREMENT_ERROR:
    case ADD_MEASUREMENT_ERROR:
    case UPDATE_MEASUREMENT_ERROR:
      return {
        ...state,
        status: 'ERROR',
        error: action.error,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./client/src/reducers/growthChartReducer.js